import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CapicheMaterialModule } from 'capiche-material';
import { ColorPaletteService } from './color-palette.service';

@Component({
  selector: 'app-color-palette',
  imports: [CommonModule, CapicheMaterialModule],
  templateUrl: './color-palette.component.html',
  styleUrl: './color-palette.component.css',
})
export class ColorPaletteComponent {
  constructor(private colorPaletteService: ColorPaletteService) {}

  colors: string[] = [
    '#faf5c8',
    'rgb(255, 255, 255)',
    'rgb(220, 230, 242)',
    'rgb(154, 184, 252)',
    'rgb(166, 248, 227)',
    'rgb(252, 213, 181)',
    'rgb(227, 176, 175)',
    'rgb(217, 217, 217)',
    'rgb(170, 242, 160)',
    'rgb(255, 255, 143)',
    'rgb(255, 222, 117)',
    'rgb(191, 149, 223)',
  ];
  selectedColor: string = '#faf5c8';

  selectColor(color: string) {
    this.selectedColor = color;
    this.colorPaletteService.changeColor(color);
  }
}
